import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	giveFeedback: {
		id: 'issue.views.common.child-issues-panel.heading.meatballs.give-feedback',
		defaultMessage: 'Give feedback',
		description: 'An action link to give feedback on the child issues panel',
	},
});
